import "../styles/footer.css";
import Logo from "../assets/logo.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="container footer-container">
        <div className="footer-brand">
          <img
            src={Logo}
            alt="CARPE Ministries"
            className="footer-logo"
          />

          <p>
            Helping people move from hardship to hope through awareness,
            resources, prevention, education, and support.
          </p>
        </div>

        <div className="footer-links">
          <span>Explore</span>

          <a href="#about">About</a>
          <a href="#programs-section">Programs</a>
          <a href="#testimonials-section">Testimonials</a>
          <a href="#give-section">Give</a>
        </div>

        <div className="footer-mission">
          <span>Our Mission</span>

          <h3>
            BOOTS TO
            <br />
            THE GROUND.
          </h3>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>&copy; CARPE Ministries {year}</p>

        <p>Life Now.</p>
      </div>
    </footer>
  );
};

export default Footer;